export const enum ExtensionPromptVariable {
    ExtensionURL = "extensionURL",
    ExtensionContentTitle = "extensionContentTitle",
    ExtensionContext = "extensionContext",
    ExtensionSelection = "extensionSelection",
}
